{
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading.t-30": [
    {
      "type": 0,
      "value": "Consumption-based pricing will come into effect soon"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading.t-90": [
    {
      "type": 0,
      "value": "Consumption-based pricing will come into effect in "
    },
    {
      "type": 1,
      "value": "daysRemaining"
    },
    {
      "type": 0,
      "value": " days"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro.t-30": [
    {
      "type": 0,
      "value": "This is a reminder that consumption-based pricing begins on "
    },
    {
      "type": 1,
      "value": "cbpEffectiveDate"
    },
    {
      "type": 0,
      "value": ". Extra usage of Assets and the virtual service agent will incur charges."
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro.t-90": [
    {
      "type": 0,
      "value": "Just a gentle reminder that you are nearing the end of your grace period. In "
    },
    {
      "type": 1,
      "value": "daysRemaining"
    },
    {
      "type": 0,
      "value": " days the consumption-based pricing will come into effect and your extra usage will be charged."
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know.t-30": [
    {
      "type": 0,
      "value": "Helpful things to know:"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know.t-90": [
    {
      "type": 0,
      "value": "Helpful things to know:"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text.t-30": [
    {
      "type": 0,
      "value": "comment"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text.t-90": [
    {
      "type": 0,
      "value": "comment"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.explore-add-ons-button.t-90": [
    {
      "type": 0,
      "value": "Explore add-ons"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text.t-30": [
    {
      "type": 0,
      "value": "lightbulb"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text.t-90": [
    {
      "type": 0,
      "value": "lightbulb"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema.t-30": [
    {
      "children": [
        {
          "type": 0,
          "value": "Contact support"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " if you have any questions"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema.t-90": [
    {
      "children": [
        {
          "type": 0,
          "value": "Contact support"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " if you have any questions"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit.t-30": [
    {
      "type": 0,
      "value": "Consider "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "optimizing the structure of your schemas"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit.t-90": [
    {
      "type": 0,
      "value": "Consider "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "optimizing the structure of your schemas"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button.t-30": [
    {
      "type": 0,
      "value": "More details"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject.t-30": [
    {
      "type": 0,
      "value": "Consumption-based pricing starts in "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "daysRemaining"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject.t-90": [
    {
      "type": 0,
      "value": "You are nearing the end of your Grace period"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide.t-30": [
    {
      "type": 0,
      "value": "For more information, read more about "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "how feature usage limits work"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide.t-90": [
    {
      "type": 0,
      "value": "For more information, read more about "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "how feature usage limits work"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button.t-30": [
    {
      "type": 0,
      "value": "View and manage usage"
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.body.atlassian-support": [
    {
      "type": 0,
      "value": "Contact Atlassian Support"
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.body.footer-info": [
    {
      "type": 0,
      "value": "You're receiving this message because your team is affected by the packaging changes announced on Oct 16, 2024."
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.body.grace-period-info": [
    {
      "type": 0,
      "value": "Your team will lose access to changes, advanced incident management, problems, and post-incident reviews on "
    },
    {
      "type": 1,
      "value": "gpEndDate"
    },
    {
      "type": 0,
      "value": ". This is a part of the pricing and packaging announcements made by us on Oct 16, 2024 for Jira Service Management."
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.body.heading": [
    {
      "type": 0,
      "value": "Retain your team's key capabilities - upgrade to Jira Service Management Premium before "
    },
    {
      "type": 1,
      "value": "gpEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.body.learn-more": [
    {
      "type": 0,
      "value": "More about what's changing: "
    },
    {
      "type": 1,
      "value": "learnMoreLink"
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.body.learn-more-link": [
    {
      "type": 0,
      "value": "Atlassian Support Article"
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.body.need-help": [
    {
      "type": 0,
      "value": "Talk to us: "
    },
    {
      "type": 1,
      "value": "supportLink"
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.body.recommendation": [
    {
      "type": 0,
      "value": "We recommend upgrading to Jira Service Management Premium to avoid any disruptions to your team."
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.body.try-premium-for-free": [
    {
      "type": 0,
      "value": "Try Premium for free"
    }
  ],
  "jsm-sequoia.jsm-gpc-notifications.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "[Action required] In 30 days, you'll lose access to changes, advanced incident management, and problems."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ]
}